import React from "react";

const NotFound = () => {
  return <>Page 404</>;
};

export default NotFound;
